import AdminLoadable from 'components/core/AdminLoadable';

export default AdminLoadable({
  loader: () => import('./MaestroLivestreamPreview'),
  name: 'MaestroLivestreamPreview',
});
